import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';
import { CreateStep } from './CreateStep';
import { CreateStepArgs } from './types';

type CreateStepperProps<T> = {
  steps: CreateStepArgs<T>[];
  currentStepIndex: number;
  className?: string;
  stepClassNames?: ComponentProps<typeof CreateStep>['classNames'];
};

export const CreateStepper = <T,>({ steps, currentStepIndex, className, stepClassNames }: CreateStepperProps<T>) => {
  return (
    <ul className={twMerge('flex px-9 pt-5 pb-2', className)} role='list' aria-label='Progress steps'>
      {steps.map((step, index) => (
        <CreateStep<T>
          key={step.id.toString()}
          index={index}
          isSelected={currentStepIndex === index}
          isCompleted={step.isCompleted}
          classNames={stepClassNames}
          {...step}
        />
      ))}
    </ul>
  );
};
